export interface IPositionsState {}

let positionsState: IPositionsState = {};

export default positionsState;